export const Audiences = {
  state: () => ({
    data: []
  })
}
